import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { accordionEvents as dlTrackAccordionEvents } from 'app/analytics/pdpEventsAnalytics';
import { isEnterPressed } from 'app/utils/accessibility/accessibilityUtils';
import createAccordion from '../../cmscomponents/accordion/accordion';
import Ratings from './ratings';
import Reviews from './reviews';

class RatingsAndReviews extends Component {
  static getStarsRating(bvRatingsEl) {
    return new Promise(resolve => {
      const INTERVAL = 500;
      const domElementInterval = setInterval(() => {
        const bvRatingsNumberEl = bvRatingsEl.querySelector('.bv_numReviews_component_container');
        const bvRatingsAvgNumberEl = document.querySelector('.bv_avgRating_component_container');
        const bvRatingsAvgNumberParsed = bvRatingsAvgNumberEl ? parseFloat(bvRatingsAvgNumberEl.innerText) : 0;
        if (bvRatingsNumberEl) {
          clearInterval(domElementInterval);
          const bvRatingsNumberParsed = parseInt(bvRatingsNumberEl.innerText.replace(/[^0-9]/g, ''), 10);
          resolve({
            numberOfReviews: !Number.isNaN(bvRatingsNumberParsed) && bvRatingsNumberParsed ? bvRatingsNumberParsed : 0,
            avgNumberOfStars:
              !Number.isNaN(bvRatingsAvgNumberParsed) && bvRatingsAvgNumberParsed ? bvRatingsAvgNumberParsed : 0,
            starsHtmlElement: bvRatingsEl.querySelector('.bv_stars_component_container').innerHTML,
          });
        }
      }, INTERVAL);
    });
  }

  constructor() {
    super();

    this.minAvgNumberOfStars = 3;

    this.state = {
      display: false,
      reviewsNumber: 0,
      ratingStars: '',
    };

    this.setRef = (ref, type) => {
      if (type === 'ratings') {
        this.ratingsRef = ref;
      } else if (type === 'reviews') {
        this.reviewsRef = ref;
      }
    };

    this.createRatingsAndReviews = this.createRatingsAndReviews.bind(this);
    this.bindAutoFocusOnClick = this.bindAutoFocusOnClick.bind(this);
  }

  componentDidMount() {
    this.createRatingsAndReviews();
    this.bindAutoFocusOnClick();
  }

  componentDidUpdate(prevProps) {
    const { productCode } = this.props;
    if (prevProps.productCode !== productCode) {
      this.createRatingsAndReviews();
      this.bindAutoFocusOnClick();
    }
  }

  bindAutoFocusOnClick() {
    this.ratingsRef.addEventListener('keydown', e => {
      if (isEnterPressed(e)) {
        this.reviewsRef.querySelector('.accordion-trigger').focus();
      }
    });
  }

  createRatingsAndReviews() {
    RatingsAndReviews.getStarsRating(this.ratingsRef).then(data => {
      this.setState(
        {
          avgNumberOfStars: data.avgNumberOfStars,
          reviewsNumber: data.numberOfReviews,
          ratingStars: data.starsHtmlElement,
          display: data.numberOfReviews && data.avgNumberOfStars >= this.minAvgNumberOfStars,
        },
        () => {
          const { display } = this.state;
          if (display) {
            const reviewsAccordion = createAccordion(this.reviewsRef).init();
            dlTrackAccordionEvents();
            this.ratingsRef.addEventListener(
              'click',
              e => {
                e.stopPropagation();
                window.scrollTo(
                  0,
                  this.reviewsRef.getBoundingClientRect().top +
                    window.pageYOffset -
                    document.querySelector('.header').offsetHeight
                );
                if (!this.reviewsRef.classList.contains('active')) {
                  reviewsAccordion.openPanel(0);
                }
              },
              true
            );
          }
        }
      );
    });
  }

  render() {
    const { productCode } = this.props;
    const { reviewsNumber, display, ratingStars, avgNumberOfStars } = this.state;
    const commonProps = {
      productCode,
      reviewsNumber,
      display,
      avgNumberOfStars,
      setRef: this.setRef,
    };

    return (
      <Fragment>
        <Ratings {...commonProps} />
        <Reviews {...commonProps} ratingStars={ratingStars} />
      </Fragment>
    );
  }
}

const mapStateToProps = ({ detailsPage }) => ({
  productCode: detailsPage.loadedProduct.productCode,
});

export default connect(mapStateToProps)(RatingsAndReviews);
